theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector("header");
    const headerSection = document.querySelector("#shopify__header__section");
    const headerStickyTargetList = document.querySelectorAll(".header__sticky");

    if (!headerStickyWrapper || !headerStickyTargetList.length) return;

    const stickyLogoBarEnabled =
      headerSection && headerSection.dataset.stickyLogoBar === "true";

    const stickyLogoTriggerPercent =
      headerSection && headerSection.dataset.stickyLogoTriggerPercent
        ? Number(headerSection.dataset.stickyLogoTriggerPercent)
        : 20;

    let ticking = false;

    /*
      关键优化：
      stickyHasBeenActivated 用来记录 Logo栏是否已经出现过。
      一旦桌面端超过设定比例出现 sticky，
      后续往上滑时不会因为低于比例就马上取消 sticky。
    */
    let stickyHasBeenActivated = false;

    function getScrollableHeight() {
      return Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight
      );
    }

    function getOriginalHeaderTriggerPoint() {
      let StickyTargetElement = TopOffset(headerStickyWrapper);
      return StickyTargetElement.top;
    }

    function getDesktopLogoBarTriggerPoint() {
      const scrollableHeight = getScrollableHeight();
      return Math.round(scrollableHeight * (stickyLogoTriggerPercent / 100));
    }

    function getTriggerPoint() {
      const isDesktop = window.innerWidth >= 992;

      if (isDesktop && stickyLogoBarEnabled) {
        return getDesktopLogoBarTriggerPoint();
      }

      return getOriginalHeaderTriggerPoint();
    }

    function addSticky() {
      headerStickyTargetList.forEach((headerStickyTarget) => {
        headerStickyTarget.classList.add("sticky");
      });
    }

    function removeSticky() {
      headerStickyTargetList.forEach((headerStickyTarget) => {
        headerStickyTarget.classList.remove("sticky");
      });
    }

    function updateStickyState() {
      const scrollY = window.scrollY || window.pageYOffset;
      const isDesktop = window.innerWidth >= 992;
      const triggerPoint = getTriggerPoint();

      /*
        桌面端 + Sticky Logo Bar 开启：
        1. 下滑超过设定比例后，sticky 出现
        2. sticky 出现后，往上滑也保持固定
        3. 只有回到页面顶部附近，才取消 sticky
      */
      if (isDesktop && stickyLogoBarEnabled) {
        const topResetPoint = 10;

        if (scrollY <= topResetPoint) {
          stickyHasBeenActivated = false;
          removeSticky();
        } else if (scrollY > triggerPoint || stickyHasBeenActivated) {
          stickyHasBeenActivated = true;
          addSticky();
        } else {
          removeSticky();
        }
      } else {
        /*
          移动端、或者没有开启 Sticky Logo Bar：
          保持主题原来的 sticky 逻辑。
        */
        if (scrollY > triggerPoint) {
          addSticky();
        } else {
          removeSticky();
        }
      }

      ticking = false;
    }

    function requestStickyUpdate() {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyState);
        ticking = true;
      }
    }

    window.addEventListener("scroll", requestStickyUpdate, { passive: true });
    window.addEventListener("resize", function () {
      stickyHasBeenActivated = false;
      requestStickyUpdate();
    });
    window.addEventListener("load", requestStickyUpdate);

    requestStickyUpdate();
  }

  return ScrollSticky;
})();